import $ from 'jquery';
import { Controller } from 'stimulus';

export default class extends Controller {
  static outlets = ['ui--toast'];

  connect() {
    // currently, only one container per page is allowed
    const firstContainer = document.querySelectorAll(`[data-controller^="${this.identifier}"]`)[0];
    if (firstContainer !== this.element) {
      console.error(
        new Error(`Only one instance of ${this.identifier} is allowed, disconnecting...`)
      );
      this.element.remove();
    }

    // Modify positions according to the context
    $(document).on($.modal.OPEN, this.#moveToTopRight);
    $(document).on($.modal.CLOSE, this.#moveBesideSidepanel);
  }

  disconnect() {
    $(document).off($.modal.OPEN, this.#moveToTopRight);
    $(document).off($.modal.CLOSE, this.#moveBesideSidepanel);
  }

  #moveToTopRight = () => {
    this.element.style.position = 'absolute';
    this.element.style.top = '0px';
    this.element.style.right = '20px';
  };

  #moveBesideSidepanel = () => {
    this.element.style.position = 'initial';
    this.element.style.top = '';
    this.element.style.right = '';
  };

  /**
   * @param {CustomEvent} e
   * @return {void}
   */
  append({ detail }) {
    const { toast } = detail;

    if (toast.id) {
      for (const toastOutlet of this.uiToastOutlets) {
        if (toastOutlet.element.id === toast.id) {
          toastOutlet.reset();
          return;
        }
      }
    }

    this.element.appendChild(toast);
  }
}
